<template>
  <svg
    aria-hidden="true"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="250" cy="250" r="220" vector-effect="non-scaling-stroke"></circle>
    <path
      class="info-icon-letter"
      d="M267,110.29v39.86H233V110.29Zm0,77V389.71H233V187.28Z"
      vector-effect="non-scaling-stroke"
    ></path>
    <path
      d="M250,34a216.07,216.07,0,0,1,84.07,415A216.07,216.07,0,0,1,165.93,51,214.73,214.73,0,0,1,250,34m0-34C111.93,0,0,111.93,0,250S111.93,500,250,500,500,388.07,500,250,388.07,0,250,0Z"
      vector-effect="non-scaling-stroke"
    ></path>
  </svg>
</template>
